import { useEffect } from "react";
import { useSite } from "@/context/SiteContext";

export default function GoogleAnalytics() {
  const { content } = useSite();
  const gaId = content?.ga_measurement_id?.trim();

  useEffect(() => {
    if (!gaId) return;
    if (document.getElementById("ga4-script")) return;
    const consent = (() => {
      try {
        const c = JSON.parse(localStorage.getItem("dc_cookie_consent") || "null");
        return c?.accepted === true;
      } catch {
        return false;
      }
    })();
    if (!consent) return;

    const s = document.createElement("script");
    s.id = "ga4-script";
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
    document.head.appendChild(s);

    const inline = document.createElement("script");
    inline.id = "ga4-inline";
    inline.innerHTML = `window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag('js', new Date()); gtag('config', '${gaId}');`;
    document.head.appendChild(inline);
  }, [gaId]);

  return null;
}
